



















import Vue from 'vue';
import Component from 'vue-class-component';
import {AlertMessage} from '@/interfaces';
import {Prop} from 'vue-property-decorator';
import {surveyModule} from '@/store/modules';
import DialogAlert from '@/components/ui/DialogAlert.vue';
import DialogActions from '@/components/ui/DialogActions.vue';
import Dialog from '@/components/ui/Dialog.vue';

@Component({
  components: {
    Dialog,
    DialogActions,
    DialogAlert,
  },
})
export default class SendTargetedSurveyConfirmDialog extends Vue {
  @Prop() surveyId!: string;
  @Prop({default: 'send'}) action!: string;
  @Prop({default: 'Send'}) saveLabel!: string;
  private alert: AlertMessage | null = null;

  get busy(): boolean {
    return surveyModule.busy;
  }

  get sending(): boolean {
    return surveyModule.saving;
  }

  async cancel() {
    this.$emit('close');
  }

  async send() {
    try {
      await surveyModule.action({
        attributes: {
          action: this.action,
          surveyId: this.surveyId,
        },
      });
      this.$emit(
        'close',
        `Survey has been ${this.action === 'send' ? 'sent' : 'resent'}`
      );
      const survey = surveyModule.find(this.surveyId);
      survey.attributes.sentDate = new Date();
      survey.attributes.sentFlag = true;
    } catch (err) {
      console.error(err);
      const error = err.response?.data?.errors[0]?.detail;
      this.alert = {
        type: 'error',
        message: `Error: ${error ? error : ''}`,
      };
    }
  }
}
